<template>
    <div v-if="staticType && isLoading" class="loading"></div>

    <div v-else-if="fixedType && isLoading" class="loading-fixed">
        <div class="loading-fill">
            <div class="loading"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Loading",
    props: {
        type: String,
        isLoading: Boolean
    },
    data() {
        return {
            staticType: false,
            fixedType: false
        };
    },
    watch: {},
    computed: {},
    methods: {
        getType() {
            if (this.type === "static") {
                this.staticType = true;
            } else if (this.type === "fixed") {
                this.fixedType = true;
            } else {
                this.staticType = true;
            }
        }
    },
    mounted() {
        this.getType();
    }
};
</script>

<style lang="scss">
.loading {
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 2px solid rgba(var(--vs-primary), 1);
    border-bottom: 2px solid transparent;
    border-left: 2px solid transparent;

    animation: spinner 600ms ease-out infinite;
}

.loading-fixed {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: white, $alpha: 0.5);
    z-index: 1000;

    .loading-fill {
        position: absolute;
        top: 50%;
        left: 50%;
        transform-origin: center;
        transform: translate(-50%, -50%);
    }
}

.theme-dark {
    .loading-fixed {
        background-color: rgba($color: #262c49, $alpha: 0.5);
    }
}

.loyalty-page {
    .loading-fixed {
        background-color: rgba($color: #333, $alpha: 0.5);
    }
}

@keyframes spinner {
    from {
        transform: rotate(0);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>



// WEBPACK FOOTER //
// src/layouts/components/Loading/Loading.vue